// src/context/SavedProductsContext.js
import React, { createContext, useContext, useState } from 'react';
import api from '../api';

const SavedProductsContext = createContext();

export const SavedProductsProvider = ({ children }) => {
  const [savedProductIds, setSavedProductIds] = useState([]);
  const [savedProductData, setSavedProductData] = useState([]);

  const fetchSavedProducts = async (username) => {
    const safeUsername = username || JSON.parse(localStorage.getItem('barterfi_user'))?.username;

    if (!safeUsername) {
      console.error('❌ No valid username for fetchSavedProducts');
      return;
    }

    try {
      const res = await api.get(`/products/saved/${safeUsername}`);
      const products = res.data || [];
      setSavedProductIds(products.map((p) => p._id));
      setSavedProductData(products); // ✅ full product data
    } catch (err) {
      console.error('❌ Failed to fetch saved products:', err);
    }
  };

  const toggleSave = async (productId, username) => {
    const safeUsername = username || JSON.parse(localStorage.getItem('barterfi_user'))?.username;

    if (!safeUsername) {
      console.error('❌ No valid username found for toggleSave');
      return;
    }

    try {
      await api.post(`/products/${productId}/save`, { username: safeUsername });

      // Optimistic update
      setSavedProductIds((prev) =>
        prev.includes(productId)
          ? prev.filter((id) => id !== productId)
          : [...prev, productId]
      );

      // 🔁 Re-fetch to sync actual saved data
      await fetchSavedProducts(safeUsername);
    } catch (err) {
      console.error('❌ Toggle save failed:', err);
    }
  };

  return (
    <SavedProductsContext.Provider
      value={{
        savedProductIds,
        savedProductData,
        toggleSave,
        fetchSavedProducts,
      }}
    >
      {children}
    </SavedProductsContext.Provider>
  );
};

export const useSavedProducts = () => useContext(SavedProductsContext);
